import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings as SettingsIcon, Flame, House, LogOut } from 'lucide-react';

export default function Header({ title, subtitle, showBack = false, showSettings = true, rightAction }) {
  const navigate = useNavigate();
  const location = useLocation();

  const goHome = () => navigate('/');

  const exitScreen = () => {
    const currentUrl = window.location.href;
    const referrer = document.referrer;

    // Prefer returning to caller page when app was opened from another screen.
    if (referrer && referrer !== currentUrl) {
      window.location.href = referrer;
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    if (location.pathname !== '/') {
      navigate('/');
      return;
    }

    // Last-resort fallback for direct-open local sessions.
    window.location.replace('about:blank');
  };

  return (
    <header className="saffron-gradient text-white shadow-lg sticky top-0 z-30">
      <div className="max-w-5xl mx-auto px-4 py-4 flex items-center gap-3">
        {showBack ? (
          <button
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Back"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        ) : (
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
            <Flame className="w-5 h-5" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="text-lg sm:text-xl font-bold truncate devanagari-ui">{title}</h1>
          {subtitle && <p className="text-xs sm:text-sm text-orange-50/90 truncate">{subtitle}</p>}
        </div>
        <button
          onClick={goHome}
          className={`px-2.5 py-1.5 rounded-lg text-xs sm:text-sm font-medium flex items-center gap-1.5 transition-colors ${
            location.pathname === '/' ? 'bg-white/25 cursor-default' : 'hover:bg-white/20'
          }`}
          aria-label="Home"
          disabled={location.pathname === '/'}
          title="Home"
        >
          <House className="w-4 h-4" />
          <span>Home</span>
        </button>
        <button
          onClick={exitScreen}
          className="px-2.5 py-1.5 rounded-lg text-xs sm:text-sm font-medium flex items-center gap-1.5 hover:bg-white/20 transition-colors"
          aria-label="Exit"
          title="Exit"
        >
          <LogOut className="w-4 h-4" />
          <span>Exit</span>
        </button>
        {rightAction}
        {showSettings && !rightAction && (
          <button
            onClick={() => navigate('/settings')}
            className="p-2 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Settings"
          >
            <SettingsIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    </header>
  );
}
